/**
 * Profile use cases – get/update current user profile, upload avatar. Uses UserRepository.
 */
import { userRepo } from '../../data/repositories/UserRepository';
import { uploadAvatar as uploadAvatarToStorage } from '../../data/firebase/storage';

export async function getProfile(userId) {
  return userRepo.getById(userId);
}

export function subscribeProfile(userId, onUpdate) {
  return userRepo.subscribe(userId, onUpdate);
}

export async function updateProfile(userId, data) {
  await userRepo.set(userId, data);
}

/** Upload profile image and set avatarUrl on user. Returns new avatar URL. */
export async function uploadProfileImage(userId, file) {
  const avatarUrl = await uploadAvatarToStorage(userId, file);
  await userRepo.set(userId, { avatarUrl });
  return avatarUrl;
}

/** List users (e.g. for compare / select athlete). */
export async function listUsers(limitCount = 100) {
  return userRepo.list(limitCount);
}
